















































































import {Component, Vue} from 'vue-property-decorator';
import {
	ServiceRecordDTO,
	ServiceRecordFilter
} from "@/components/payroll/business/services/ServiceDTO";
import Application from "@/state/Application";
import ServiceRecordOrchestrator from "@/services/ServiceLogOrchestrator";
import Page, {EMPTY_PAGE} from "@/dto/taxation/Page";
import {processError} from "@/utils/ComponentUtils";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import ServiceLogView from "@/components/payroll/business/services/ServiceLogView.vue";
import ServiceInvoiceItem from "@/components/payroll/business/services/ServiceInvoiceItem.vue";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";
import {subSrtIfNeed} from "../../../../utils/StringUtils";
import PortalRadio from "@/components/v2/common/PortalRadio.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import ProvideServiceAsContractor from "@/components/payroll/business/services/service/ProvideServiceAsContractor.vue";
import ServiceLogUpdateSlider from "@/components/payroll/business/services/service/ServiceLogUpdateSlider.vue";
import ServiceLogViewSlider from "@/components/payroll/business/services/service/ServiceLogViewSlider.vue";

@Component({
	methods: {subSrtIfNeed},
	components: {
		ServiceLogViewSlider,
		ServiceLogUpdateSlider,
		ProvideServiceAsContractor,
		RightSideBar, PortalDate, PortalRadio, ServiceInvoiceItem, ServiceLogView, PaginationComponent}
})
export default class ContractorServiceLogList extends Vue {

	private records: Page<ServiceRecordDTO> = EMPTY_PAGE;
	private open = false
	private updateLog = false;
	private viewLog = false;

	private filter = new ServiceRecordFilter();
	private selectedLog: ServiceRecordDTO | null = null;

	mounted() {
		Application.startLoading()
		this.filter.executorId = this.$wss.getCurrent.id
		this.loadServiceRecords()
			.finally(() => Application.stopLoading())
	}

	private loadServiceRecords() {
		if (this.filter.executorId == null) return Promise.reject()
		return ServiceRecordOrchestrator.getPageByFilter(this.filter).then(
			res => {this.records = res.data},
			err => processError(err, this)
		)
	}

	private loadPage(page: number) {
		this.filter.page = page - 1
		this.loadServiceRecords()
	}

	private loadNextPage() {
		this.filter.page = this.filter.page + 1
		this.loadServiceRecords()
	}

	private close(record: ServiceRecordDTO) {
		(this.$refs[`popover_${record.id}`] as Array<Vue>)[0].$emit("close")
	}

	private disable(record: ServiceRecordDTO) {
		this.$modal.show(
			DeleteConfirmation,
			{
				onDelete: () => {
					Application.startLoading()
					ServiceRecordOrchestrator.disableLog(record.id, record.executor.id).then(
						() => {
							Application.startLoading()
							return Promise.all(
								[
									this.loadServiceRecords(),
								]
							).finally(Application.stopLoading)
						},
						err => processError(err, this)
					).finally(Application.stopLoading)
				},
				targetName: `"${record.title}"`,
				operationName: 'disable'
			}
		)
	}

	private update() {
		Application.startLoading()
		return Promise.all(
			[
				this.loadServiceRecords(),
			]
		).finally(Application.stopLoading)
	}

	private openLog(log: ServiceRecordDTO) {
		this.selectedLog = log
		if (log.executor.userId == this.$wss.getCurrent.userId) {
			this.updateLog = true;
		} else {
			this.viewLog = true;
		}
	}

}
